import type {PreOrderRetrieveResponse} from '@yandex-delivery/api/repo/dcaa'

import type {Order as FormValues} from 'src/shared/types'

type Due = Partial<Pick<FormValues['offerFlow'], 'deliveryType' | 'deliveryDate' | 'deliveryTime' | 'deliveryInterval'>>

export const toDue = (preOrderRetrieve: PreOrderRetrieveResponse): Due => {
  const offerRequirements = preOrderRetrieve.claim.offer_requirements

  if (!offerRequirements?.due) {
    return {
      deliveryType: 'now',
    }
  }

  const date = new Date(offerRequirements.due)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()

  const deliveryDate = `${day}.${month}.${year}`

  const isoStringDate = date.toISOString()

  const deliveryInterval = {
    from: isoStringDate,
    to: isoStringDate,
  }

  return {
    deliveryType: 'toTime',
    deliveryDate,
    deliveryInterval,
  }
}
